module.exports = __webpack_public_path__ + "static/media/tot_prv.1cb0effd.svg";